import { ContentCardHeader } from 'components/ui/ContentCardHeader';
import { DataGrid, DataGridSortOrder } from 'components/ui/DataGrid';
import { FontAwesomeIcon } from 'components/ui/FontAwesomeIcon';
import { GridContainer } from 'components/ui/Grid';
import { openCoachingForm } from 'containers/CoachingFormsContainer/lib/utils';
import * as _ from 'lodash'
import * as React from 'react';
import { Alert, Button, Card, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { userData } from 'util/userData';
import { deleteClient, deleteSelectedSurveys, getSurveys, ISurvey } from './lib/http';


interface IAdminSurveysProp {
  filterChange: boolean
}

interface IAdminSurveysState {
  selectedSurveys: number[]
  surveys?: ISurvey[]
  sortBy: keyof ISurvey
  sortOrder: DataGridSortOrder
  loading: boolean
  errMessage?: string
  deleteAllWorking?: boolean
  deleteSelectedWorking?: boolean
  deleteSelectModal: boolean
  deleteAllModal: boolean
  confirmText: string
  confirmErrorMessage: string
  deleteAlerts: boolean
  surveysToDelete: string
}

export class AdminSurveysContainer extends React.Component<IAdminSurveysProp, IAdminSurveysState> {

  state: IAdminSurveysState = {
    selectedSurveys: [],
    surveys: [],
    sortBy: 'interviewDate',
    sortOrder: 'asc',
    loading: false,
    deleteAllWorking: false,
    deleteSelectedWorking: false,
    deleteSelectModal: false,
    deleteAllModal: false,
    confirmText: '',
    confirmErrorMessage: '',
    deleteAlerts: false,
    surveysToDelete: '',
  }

  constructor(props) {
    super(props)

    this.toggleAll = this.toggleAll.bind(this)
    this.toggleSelected = this.toggleSelected.bind(this)
  }

  removeUserDataListener: () => void = () => { /**/ }

  componentWillMount() {
    this.removeUserDataListener = userData.listen('filters', (filters) => this.filtersUpdates(filters))
  }

  filtersUpdates(filters) {
    this.setState({ loading: true })
    getSurveys(filters).then((surveyResponse) => {
      this.setState({ surveys: surveyResponse.data, loading: false, surveysToDelete: surveyResponse.surveysToBeDeleted })
      const hideAllPeriodsWarning = new CustomEvent('hideAllPeriodsWarning', {});
      window.dispatchEvent(hideAllPeriodsWarning);
    }).catch((err) => { this.setState({ loading: false }) })
  }

  renderBulkCheck(record: ISurvey) {
    const disableActions = false
    const isSelected = this.isSelected(record)
    const isNotSelected = !isSelected
    const icon = isSelected ? 'check-square' : 'square'
    const className = (isNotSelected || disableActions) ? 'text-dark' : ''
    const iconElement = (
      <FontAwesomeIcon className={className}
        verticalAlign="initial"
        icon={icon}
        regular={isNotSelected && !disableActions} />
    )

    if (disableActions) {
      return (<span>{iconElement}</span>)
    }

    return (
      <a href="javascript:void(0)" onClick={() => this.toggleSelectedCoachingForm(record)}>
        {iconElement}
      </a>
    )
  }

  toggleSelectedCoachingForm(record: ISurvey) {
    const { selectedSurveys } = this.state
    const selectedIndex = selectedSurveys.indexOf(record.externalDataReference)

    if (selectedIndex >= 0) {
      selectedSurveys.splice(selectedIndex, 1)
    } else {
      selectedSurveys.push(record.externalDataReference)
    }

    this.setState({ selectedSurveys })
  }

  isSelected(record: ISurvey) {
    const { selectedSurveys } = this.state
    const selectedIndex = selectedSurveys.indexOf(record.externalDataReference)

    return selectedIndex >= 0
  }

  renderIdColumn(record: ISurvey) {
    return (
      <a href="javascript:void(0)" onClick={() => this.openCoachingForm(record)}>
        <FontAwesomeIcon icon="search" verticalAlign="initial" size="md" />
        <span>&nbsp;{record.externalDataReference}</span>
      </a>
    )
  }

  openCoachingForm(record: ISurvey) {
    const { abbr_survey, externalDataReference, ai } = record

    openCoachingForm(externalDataReference, { ai, abbr_survey })
  }

  deleteSelected() {
    const { selectedSurveys, confirmText, deleteAlerts } = this.state

    this.setState({ deleteSelectedWorking: true, loading: true })

    deleteSelectedSurveys(selectedSurveys, deleteAlerts).then(() => {
      getSurveys().then((surveyResponse) => {
        this.setState({ surveys: surveyResponse.data, surveysToDelete: surveyResponse.surveysToBeDeleted, selectedSurveys: [], deleteSelectedWorking: false, loading: false })
      }).catch((err) => this.setErrorMessage(err))
    }).catch((err) => this.setErrorMessage(err))
  }

  setErrorMessage(errMessage: string) {
    this.setState({ errMessage, deleteAllWorking: false, deleteSelectedWorking: false }, () => {
      setTimeout(() => {
        this.setState({ errMessage: null })
      }, 5000)
    })
  }

  deleteClient() {
    const { confirmText, deleteAlerts } = this.state
    if (confirmText.toLowerCase() === 'delete') {
      this.setState({ deleteAllWorking: true, loading: true, confirmErrorMessage: '' })
      deleteClient(deleteAlerts).then(() => {
        getSurveys().then((surveyResponse) => {
          this.setState({ surveys: surveyResponse.data, surveysToDelete: surveyResponse.surveysToBeDeleted, selectedSurveys: [], deleteAllWorking: false })
        }).catch((err) => this.setErrorMessage(err))
      }).catch((err) => this.setErrorMessage(err))
    } else {
      this.setState({ confirmErrorMessage: 'Confirmation text does not match' })
    }
  }

  selectAllCoachingForms() {
    const { surveys } = this.state
    const selectedCoachingFormIds = surveys.map((r) => r.externalDataReference)
    this.setState({ selectedSurveys: selectedCoachingFormIds })
  }

  selectNoneForCoachingForms() {
    const selectedSurveys = []

    this.setState({ selectedSurveys })
  }

  toggleAll() {
    const { deleteAllModal } = this.state

    this.setState({ deleteAllModal: !deleteAllModal, confirmText: '', confirmErrorMessage: '' })
  }

  toggleSelected() {
    const { deleteSelectModal, confirmText } = this.state

    this.setState({ deleteSelectModal: !deleteSelectModal, confirmText: '', confirmErrorMessage: '' })
  }

  render() {
    const { surveys, selectedSurveys, loading, errMessage, deleteAllWorking, deleteSelectedWorking, deleteAllModal, deleteSelectModal } = this.state
    const hasData = surveys.length > 0
    const hasNoData = surveys.length === 0
    const selectedLength = selectedSurveys.length
    const recordsLength = surveys.length
    const shouldDisableBulkSelectAll = selectedLength === recordsLength
    const noneSelected = selectedLength <= 0
    const coachingDataQuestion = ''

    return (
      <section className="blacklight page-container">
        <GridContainer>
          <Card>
            <ContentCardHeader
              sticky
              borderBottom
              header={
                <section className="d-md-flex justify-content-between">
                  <article>
                    <span>Coaching Forms</span>
                    {loading &&
                      <FontAwesomeIcon icon="cog" size="sm" verticalAlign="middle" spin />
                    }
                    {!noneSelected &&
                      <small>:&nbsp;{selectedLength.toLocaleString()}&nbsp;selected</small>
                    }
                    {errMessage &&
                      <Alert color="red"></Alert>
                    }
                  </article>
                </section>
              }
              headerActions={
                <section className="mt-2 d-md-flex justify-content-between">
                  <article>
                    <Button className="mr-2" color="primary" id="deleteSelectedBtn"
                      disabled={noneSelected}
                      onClick={() => confirm('Are you sure you want to delete the selected surveys') ? this.deleteSelected() : null}>
                      Delete Selected Surveys
                    </Button>
                    <Button className="mr-2" color="destructive" disabled={deleteAllWorking} id="deleteAllBtn"
                      onClick={() => this.toggleAll()}>
                      Delete Whole Client
                    </Button>
                    <Button className="mr-2" color="primary" id="selectAllBtn"
                      disabled={shouldDisableBulkSelectAll}
                      onClick={() => this.selectAllCoachingForms()}>
                      Select All
                    </Button>
                    <Button className="mr-2" color="primary" id="clearSelectionBtn"
                      disabled={noneSelected}
                      onClick={() => this.selectNoneForCoachingForms()}>
                      Clear Selection
                    </Button>
                    <article style={{ padding: "10px 10px 0 10px" }}>
                      <input type="checkbox" value={this.state.deleteAlerts ? 1 : 0} id="deleteAlerts" onChange={(e) => this.setState({ deleteAlerts: e.currentTarget.checked })}></input>
                      <Label htmlFor="deleteAlerts">Delete notes, status, and alerts?</Label>
                    </article>
                  </article>
                </section>}
            />
            {hasNoData &&
              <Alert color="warning" className="animated fadeIn">
                <FontAwesomeIcon icon="sticky-note" verticalAlign="initial" size="md" />
                <span>&nbsp;No data found for the current filters.</span>
              </Alert>
            }
            {this.state.surveysToDelete !== '' &&
              <Alert color="warning" className="animated fadeIn">
                Surveys scheduled to be deleted: {this.state.surveysToDelete}
              </Alert>
            }
            {hasData &&
              <DataGrid<ISurvey>
                className="animated fadeIn"
                sortBy={this.state.sortBy}
                sortOrder={this.state.sortOrder}
                onSortChange={(sortBy, sortOrder) => this.setState({ sortBy, sortOrder })}
                records={surveys}
                columns={[
                  { header: '', sortable: false, width: 55 },
                  { header: 'Bulk', align: 'center', width: 55, sortable: false, render: (avid) => this.renderBulkCheck(avid) },
                  { header: 'ID', property: 'externalDataReference', render: (record) => this.renderIdColumn(record) },
                  { property: 'interviewDate', header: 'Date' },
                  { property: 'organization', header: 'Team' },
                  { property: 'survey', header: 'Survey' },
                  { property: 'response', header: coachingDataQuestion },
                ]} />
            }
          </Card>
        </GridContainer>
        <Modal wrapClassName="blacklight" modalClassName="blacklight-modal" isOpen={this.state.deleteAllModal} toggle={() => this.toggleAll()}>
          <ModalHeader toggle={() => this.toggleAll()}>Delete All Client Data</ModalHeader>
          <ModalBody>
            {this.state.confirmErrorMessage &&
              <Alert color="warning">
                {this.state.confirmErrorMessage}
              </Alert>
            }
            Are you sure you want to delete all client data? If so, type DELETE in the input below. <br />
            <Input type="text" value={this.state.confirmText} onChange={(e) => this.setState({ confirmText: e.currentTarget.value })} />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.toggleAll()}>Cancel</Button>
            <Button color="destructive" onClick={() => this.deleteClient()}>Delete</Button>{' '}
          </ModalFooter>
        </Modal>
      </section>
    )
  }
}

